import { render, staticRenderFns } from "./common-access-get-list.vue?vue&type=template&id=4ba1d397&scoped=true"
import script from "./common-access-get-list.vue?vue&type=script&lang=js"
export * from "./common-access-get-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba1d397",
  null
  
)

export default component.exports